import React, { useState } from "react";
import Input from "../../../components/FormComponents/Input";
import Button from "../../../components/FormComponents/Button";

const CreateRdbmsFormModal = ({ create }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [creationData, setCreationData] = useState({
    name: ""
  });

  const addRdbmsForm = async () => {
    setIsLoading(true);
    await create(creationData);
    setIsLoading(false);
  };

  return (
    <>
      <div className="builder_form">
        <Input
          label="RDBMS Name"
          name="name"
          value={creationData.name}
          onChange={(e) => setCreationData({ ...creationData, name: e.target.value })}
        />
        <Button isLoading={isLoading} onClick={addRdbmsForm}>
          Add +
        </Button>
      </div>
    </>
  );
};

export default CreateRdbmsFormModal;
